<template>
  <div class="mt-4">
    <p class="text-body-2 text-grey-body mb-16">{{ statusMessage }}</p>
    <sitter-badge-list :badges="badges" :badgeSize="badgeSize" :includeInactiveBadges="false" :certificationsOnly="true" />
  </div>
</template>

<script lang="ts">
import SitterBadgeList from '@/components/sitter_badge_list/SitterBadgeList.vue';

interface Badge {
  completedAt: Date;
  expiresAt: Date;
  name: string;
  status: string;
}

export default {
  name: 'ProfileCertifications',
  components: {
    SitterBadgeList,
  },
  props: {
    badges: {
      type: Array as () => Badge[],
      default: () => [],
    },
    hasCertifications: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      badgeSize: 60,
    };
  },
  computed: {
    statusMessage(): string {
      return this.hasCertifications ? 'These are self-reported, not verified' : 'Not reported';
    },
  },
};
</script>
